import React, { JSX } from 'react';
import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';

type PageTitleProps = StyleguideComponentProps & {
  fields: {
    Title: Field<string>;
  };
};

const PageTitle = (props: PageTitleProps): JSX.Element => {
  const { fields } = props;

  return (
    <Text
      id={`page-title-${props.rendering?.uid}`}
      className="heading-1"
      tag="h1"
      field={fields?.Title || ''}
    />
  );
};

export default PageTitle;
